/*
 * Cherry Pot — cart drawer enhancements.
 *
 * The drawer markup is server-rendered by snippets/header-actions.liquid and
 * re-rendered by Horizon's section morphing whenever the cart changes, so we
 * watch the DOM rather than running once.
 *
 * Two jobs:
 *   1. Pin the store rating strip directly under the drawer header.
 *   2. Swap Horizon's bare empty-cart text for our designed empty state.
 *
 * Both bits of markup live in <template> elements emitted by
 * layout/theme.liquid, which render the same snippets the /cart page uses —
 * one source of truth. The whole fragment is cloned (including its <style>),
 * because a <style> inside a <template> is inert until it lands in the DOM.
 */
(function () {
  var EMPTY_TPL = 'cp-cart-empty-tpl';
  var EMPTY_ATTR = 'data-cp-empty-applied';
  var RATE_TPL = 'cp-cart-rating-tpl';
  var RATE_ATTR = 'data-cp-rate-applied';
  var scheduled = false;

  function mount(templateId, className) {
    var tpl = document.getElementById(templateId);
    if (!tpl || !tpl.content) return null;

    var wrap = document.createElement('div');
    wrap.className = className;
    wrap.appendChild(tpl.content.cloneNode(true));
    return wrap;
  }

  function applyRating() {
    var headers = document.querySelectorAll('.cart-drawer .cart-drawer__header');

    for (var i = 0; i < headers.length; i++) {
      var header = headers[i];
      if (header.hasAttribute(RATE_ATTR)) continue;

      var node = mount(RATE_TPL, 'cp-rate-mount');
      if (!node) return;

      // Mark before mutating so the observer ignores our own change.
      header.setAttribute(RATE_ATTR, '');
      header.insertAdjacentElement('afterend', node);
    }
  }

  function applyEmpty() {
    var dialogs = document.querySelectorAll('.cart-drawer--empty');

    for (var i = 0; i < dialogs.length; i++) {
      var content = dialogs[i].querySelector('.cart-drawer__content');
      if (!content || content.hasAttribute(EMPTY_ATTR)) continue;

      var node = mount(EMPTY_TPL, 'cp-empty-mount');
      if (!node) return;

      content.setAttribute(EMPTY_ATTR, '');
      content.replaceChildren(node);
    }
  }

  function apply() {
    scheduled = false;
    applyRating();
    applyEmpty();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();